import { render, staticRenderFns } from "./ItemStatusComponent.vue?vue&type=template&id=cf36c72a&scoped=true"
import script from "./ItemStatusComponent.vue?vue&type=script&lang=js"
export * from "./ItemStatusComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf36c72a",
  null
  
)

export default component.exports